import axios from '@/utils/request'

/**
 * 分类列表
 */
const getClassifyList = (params, options) => axios({
  url: 'service/type',
  params,
  options
})

/**
 * 新增分类
 */
const addClassify = (data) => axios({
  url: 'service/type',
  method: 'post',
  data
})

/**
 * 删除分类
 */
const deleteClassify = (uuid) => axios({
  url: `service/type/${uuid}`,
  method: 'delete'
})

/**
 * 编辑分类
 */
const setClassify = (data) => axios({
  url: 'service/type',
  method: 'put',
  data
})

/**
 * 企业服务列表
 */
const getServeList = (params, options) => axios({
  url: 'service',
  params,
  options
})

/**
 * 新增企业服务
 */
const addCompanyServe = (data) => axios({
  url: 'service',
  method: 'post',
  data
})
/**
 * 编辑企业服务
 */
const updateCompanyServe = (data) => axios({
  url: 'service',
  method: 'put',
  data
})

/**
 * 删除企业服务
 */
const deleteCompanyServe = (uuid) => axios({
  url: `service/${uuid}`,
  method: 'delete'
})

/**
 * 企业服务详情
 */
const getServeDetails = (uuid) => axios({
  url: `service/${uuid}`
})

/**
 * 意向留言列表
 */
const getMessageList = (params, options) => axios({
  url: `service/message`,
  params,
  options
})

/**
 *导出意向留言列表Excel
 */
const getMessageExcel = params => axios({
  url: 'service/message/excel',
  responseType: 'arraybuffer',
  params
})

/**
 * 删除意向留言
 */
const deleteMessage = (uuid) => axios({
  url: `service/message/${uuid}`,
  method: 'delete'
})

/**
 * 编辑意向留言是否读取
 */
const putMessage = (data) => axios({
  url: `service/message/${data.uuid}?isRead=${data.isRead}`,
  method: 'put'
})

/**
 * 所有分类（选择时使用）
 */
const getServerList = (id) => axios({
  url: `service/type/all?industryUuid=${id}`
})

export {
  getClassifyList,
  deleteClassify,
  addClassify,
  setClassify,
  getServeList,
  getServeDetails,
  getMessageList,
  getMessageExcel,
  deleteMessage,
  putMessage,
  getServerList,
  addCompanyServe,
  updateCompanyServe,
  deleteCompanyServe
}
